import { render, staticRenderFns } from "./modals.vue?vue&type=template&id=74f15357&"
import script from "./modals.vue?vue&type=script&lang=js&"
export * from "./modals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74f15357')) {
      api.createRecord('74f15357', component.options)
    } else {
      api.reload('74f15357', component.options)
    }
    module.hot.accept("./modals.vue?vue&type=template&id=74f15357&", function () {
      api.rerender('74f15357', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/uikit/modals.vue"
export default component.exports